import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Meses from '../../services/Meses'
import MunicipiosApi from '../../services/robinhood/MunicipiosApi';

export default function MunicipioSelecionado(props) {

    return (
        <>
            <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1">
                <div class="card bg-blue-grey">
                    <a href='' data-toggle='modal' data-target='#largeModalMunicipio' className='small text-white' style={{ textDecoration: 'none', color: 'white' }}>
                        <div class="body ">
                            <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-city' style={{ fontSize: '30px' }}></i> {props.municipio.municipio}</h4>
                            <i className='zmdi zmdi-mouse small text-white'></i> <span style={{ color: 'white' }} className='blink_me'>ALTERAR MUNICÍPIO</span>
                        </div>
                    </a>
                </div>
            </div>
        </>
    )
}
